module.exports = __webpack_public_path__ + "static/img/logo-WESTERN-BULLDOGS.926f376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-WESTERN-BULLDOGS.svg
// module id = OeO9
// module chunks = 1